(function() {

  function updateStockText() {
    const blocks = document.querySelectorAll('.multivariants_block_last_holder');
    if (!blocks.length) return;

    blocks.forEach(block => {
      const qtyEl = block.querySelector('.multivariants_block_stock_qty .mkmid_m');
      if (!qtyEl) return;

      const match = qtyEl.textContent.trim().match(/\d+/);
      const qty = match ? parseInt(match[0], 10) : 0;

      const sticker = block.querySelector('.mv_out_of_stock_badge');
      if (sticker) sticker.style.display = 'none';

      if (qty < 10) {
        qtyEl.textContent = 'Out of stock';
        qtyEl.style.color = 'red';
        qtyEl.style.fontWeight = 'bold';
      } else {
        qtyEl.textContent = '10 In stock';
        qtyEl.style.color = '';
        qtyEl.style.fontWeight = '';
      }
    });
  }

  // Run once every 500ms until blocks exist, then stop
  const interval = setInterval(() => {
    const blocksExist = document.querySelectorAll('.multivariants_block_last_holder').length > 0;
    if (blocksExist) {
      clearInterval(interval);
      updateStockText();
    }
  }, 500);

  // Optional: MutationObserver, but throttled to run at most once per 1s
  let throttleTimeout;
  const observer = new MutationObserver(() => {
    if (!throttleTimeout) {
      throttleTimeout = setTimeout(() => {
        updateStockText();
        throttleTimeout = null;
      }, 1000); // 1 second throttle
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });

})();
